module.exports = __webpack_public_path__ + "static/img/Autres_FH.1f27974.jpg";